import {
  Bot,
  User,
  Globe,
  Coffee,
  Rocket,
  Bookmark,
  BookOpen,
  Sparkles,
  Briefcase,
  LineChart,
  MessageCircle,
  LayoutDashboard,
} from 'lucide-react';

import { getAuthFromStorage } from 'src/lib/auth-storage';

// ----------------------------------------------------------------------

// Helper function to create standard icons
const navIcon = (Icon: any) => (
  <Icon className="h-5 w-5 flex-shrink-0" />
);

// Check if the current user is an admin
const isAdmin = () => {
  const authData = getAuthFromStorage();
  return authData?.roles?.includes('Admin') || false;
};

export const navData = [
  {
    title: 'Dashboard',
    titleKey: 'nav.dashboard',
    path: '/dashboard',
    icon: navIcon(LayoutDashboard),
  },
  {
    title: 'Job Market',
    titleKey: 'nav.jobMarket',
    path: '/job-market',
    icon: navIcon(Briefcase),
  },
  {
    title: 'Saved Jobs',
    titleKey: 'nav.savedJobs',
    path: '/saved-jobs',
    icon: navIcon(Bookmark),
  },
  // {
  //   title: 'User',
  //   path: '/user',
  //   icon: navIcon(User),
  // },
  {
    title: 'Profile',
    titleKey: 'nav.profile',
    path: '/profile',
    icon: navIcon(User),
  },
  {
    title: '1 min Portfolio',
    titleKey: 'nav.oneMinPortfolio',
    path: '/one-min-portfolio',
    icon: navIcon(Rocket),
  },
  // {
  //   title: 'Subscription',
  //   path: '/subscription',
  //   icon: navIcon(Star),
  // },
  {
    title: 'Tree Hole',
    titleKey: 'nav.treeHole',
    path: '/tree-hole',
    icon: navIcon(MessageCircle),
  },
  {
    title: 'Coffee Chats',
    titleKey: 'nav.coffeeChats',
    path: '/coffee-chats',
    icon: navIcon(Coffee),
  },
  {
    title: 'Jobicorn',
    titleKey: 'nav.jobicorn',
    path: '/jobicorn',
    icon: navIcon(Sparkles), // Unicorn alternative
  },
  {
    title: 'Market Reports',
    titleKey: 'nav.marketReports',
    path: '/reports',
    icon: navIcon(LineChart),
  },
  {
    title: 'AI Lab',
    titleKey: 'nav.aiLab',
    path: '/ai-lab',
    icon: navIcon(Bot),
  },
  {
    title: 'Docs',
    titleKey: 'nav.docs',
    path: '/docs',
    icon: navIcon(BookOpen),
    external: true,
  },
  // Admin only menu items
  ...(isAdmin()
    ? [
        {
          title: 'Global Dashboard',
          titleKey: 'nav.globalDashboard',
          path: '/globaldashboard',
          icon: navIcon(Globe),
        },
      ]
    : []),
];
